import React from 'react';
import { useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/forgot-password';

  if (isAuthPage) {
    return (
      <footer className="footer auth-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; 2025 Literally Possible, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Literally Possible</h4>
            <p>Transforming possibilities into reality through innovative solutions and strategic consulting.</p>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Strategy Development</li>
              <li>Process Automation</li>
              <li>Custom Development</li>
              <li>Consulting</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li>About Us</li>
              <li>Careers</li>
              <li>Contact</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Literally Possible, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 